import script from "./FloatingSupport.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingSupport.vue?vue&type=script&setup=true&lang=js"

import "./FloatingSupport.vue?vue&type=style&index=0&id=7f7c8f9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f7c8f9f"]])

export default __exports__